import React, { Component } from 'react';
import Section from '../Section/Section';

class Page extends Component {
  render() {
    if (!this.props.page || !this.props.storeConfig) {
      return null;
    }

    return (
      <div className={`sections ${this.props.storeConfig.storeId}`}>
        {this.props.page.sections.map((s, idx) => (
          <Section
            key={`section-${idx}`}
            sectionIdx={idx}
            contentBlocks={s.contentBlocks}
            storeConfig={this.props.storeConfig}
            sectionConfig={{
              size: s.size,
              swipeable: s.swipeable,
              noMargins: s.noMargins
            }}
          />
        ))}
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/Page.js